// @flow

import format from 'date-fns/format';

import EnrollmentPeriodModel from 'routes/health/models/EnrollmentPeriodModel';
import type { EnrollmentPeriodResType } from 'web-core/types/enrollment';

export const hasDeadlineDisplayLogic = (enrollmentPeriods: EnrollmentPeriodResType) => {
  const { showCutoffMissed, showCutoffNear } = new EnrollmentPeriodModel(
    enrollmentPeriods.current,
    enrollmentPeriods.next,
  );

  return showCutoffMissed || showCutoffNear;
};

export const formatDeadlineDates = (date: Date) => format(date, 'MMMM Do');
export const formatDeadlineTime = (date: Date) => format(date, 'h:mma');
export const getNextMonth = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1);
};
